import FooterNotification from "./FooterNotification";

export default FooterNotification;
